var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.000000000000000267, 0.942211, -0.942211, 0.000000000000000267, 128.219674, 271.35675)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.00136003 28.001943 L 81.999087 28.001943 ",
    stroke: "#f5f5f5",
    strokeWidth: 56,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0, 0.942211, -0.942211, 0, 128.219674, 26.381906)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.000962494 28.001943 L 82.001409 28.001943 ",
    stroke: "#f5f5f5",
    strokeWidth: 56,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.942273, 0, 0, 0.942211, 75.361648, 322.236161)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00173294 27.999066 L 237.994278 27.999066 ",
    stroke: "#f5f5f5",
    strokeWidth: 56,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.942087, 0, 0, 0.942211, 75.361648, 161.118081)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00173328 28.000014 L 238.032864 28.000014 ",
    stroke: "#f5f5f5",
    strokeWidth: 56,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.942273, 0, 0, 0.942211, 75.361648, -0.000000000000042633)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00173294 28.000962 L 237.994278 28.000962 ",
    stroke: "#f5f5f5",
    strokeWidth: 56,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLite);
export default __webpack_public_path__ + "static/media/Logo-lite.baf9606aaea3e707cb98fecd618449d2.svg";
export { ForwardRef as ReactComponent };